import React, { useState } from "react";
import { Alert, Chip, Stack, Typography } from "@mui/material";
import moment from "moment-timezone";
import TimeUtils from "../../../../utils/time.utils";
import { formatPrice, formatLocalPrice } from "../../../../utils/helper";



/**
 * SlotPrev
 *
 * Displays available time slots as selectable chips.
 * Expects slots in the new API shape:
 *   { startTime: ISO string (UTC), endTime: ISO string (UTC), duration: number, price?: number }
 */
function SlotPrev({ slots = [], handleSelectSlot, exchangeRate = null }) {
  
  const [selectedKey, setSelectedKey] = useState(null);
  const userTz = TimeUtils.getCurrentTimezone();
  const exchangeValue = exchangeRate?.rate || 1;

  const uniqueSlots = slots.filter((slot, index, self) =>
    index === self.findIndex((s) =>
      s.startTime === slot.startTime && s.endTime === slot.endTime
    )
  );

  if (!uniqueSlots.length) {
    return (
      <Alert severity="warning" sx={{ mt: 2 }}>
        No slots available for this date. Please select another day.
      </Alert>
    );
  }

  return (
    <Stack mt={2} spacing={1}>
      <Typography variant="caption" color="text.secondary">
        Times shown in your local timezone ({userTz})
      </Typography>
      <Stack direction="row" flexWrap="wrap" gap={0.5}>
        {uniqueSlots.map((slot, index) => {
          const key = `${slot.startTime}-${slot.endTime}-${index}`;
          const isSelected = selectedKey === key;
          const startLocal = moment.utc(slot.startTime).tz(userTz).format("hh:mm A");
          const endLocal = moment.utc(slot.endTime).tz(userTz).format("hh:mm A");
          const priceLabel = slot?.price != null ? ` • ${formatLocalPrice(slot.price, exchangeValue, slot.currency)}` : "";

          return (
            <Chip
              size="small"
              color="primary"
              key={key}
              variant={isSelected ? "filled" : "outlined"}
              onClick={() => {
                setSelectedKey(key);
                handleSelectSlot(slot);
              }}
              label={`${startLocal} - ${endLocal}${priceLabel}`}
            />
          );
        })}
      </Stack>
    </Stack>
  );
}

export default SlotPrev;
